export const USER_NOTIFICATION_REQUEST = 'USER_NOTIFICATION_REQUEST'
export const USER_NOTIFICATION_SUCCESS = 'USER_NOTIFICATION_SUCCESS'
export const USER_NOTIFICATION_FAIL = 'USER_NOTIFICATION_FAIL'